import { Injectable } from "@angular/core";
import { Capacitor } from "@capacitor/core";
import {
  ActionPerformed,
  PushNotificationSchema,
  PushNotifications,
  Token,
} from "@capacitor/push-notifications";
import { FCM } from "@capacitor-community/fcm";
import { CustomerAPI } from "./customer_api.service";

// https://developmobileapplications.com/firebase-push-notification-in-ionic-5
// https://capacitorjs.com/docs/guides/push-notifications-firebase
// IOS : https://capacitorjs.com/docs/apis/push-notifications#ios
// IOS : APN: https://devdactic.com/push-notifications-ionic-capacitor/

// ANDROID:
// Download the google-services.json file to your local machine.
// Then move the file into your Capacitor Android project directory, specifically under android/app/.

@Injectable({
  providedIn: "root",
})
export class FcmService {
  myToken;
  constructor(private api: CustomerAPI) {}

  // initPush() {
  //   if (Capacitor.platform !== 'web') {
  //     this.registerPush();
  //   }
  // }

  async logout() {
    const data = { token: this.myToken };
    // (await this.api.deviceTokenDeregister({ data })).subscribe((result2) => {
    //   const r: any = result2;
    //   if (!r.ok) return;
    // });
  }
  initPush() {
    ///// START OF DEBUGGING FOR ANDROID

    ///// END OF DEBUGGING FOR ANDROID

    // console.log(`Capacitor.getPlatform()?`, Capacitor.getPlatform());
    if (Capacitor.getPlatform() === "web") return;
    // Request permission to use push notifications
    // iOS will prompt user and return if they granted permission or not
    // Android will just grant without prompting

    PushNotifications.checkPermissions().then((result) => {
      // console.log("check checkPermissions result??", result);
    });

    PushNotifications.requestPermissions().then((result) => {
      // console.log(`requestPermissions?`);
      // console.log(`result.receive??`, result.receive);
      if (result.receive === "granted") {
        // Register with Apple / Google to receive push via APNS/FCM
        PushNotifications.register().then((res) => {
          // console.log("From Regisiter Promise", res);
        });
      } else {
        // Show some error
      }
    });

    // On success, we should be able to receive notifications
    PushNotifications.addListener("registration", async (token: Token) => {
      // alert('Push registration success, token: ' + token.value);
      // console.log(`calling resgistration`, token, Capacitor.getPlatform());
      if (Capacitor.getPlatform() === "ios") {
        FCM.getToken()
          .then(async (result) => {
            this.myToken = result.token;
            const data = {
              platform: Capacitor.getPlatform(),
              token: this.myToken,
            };
            (await this.api.deviceTokenRegister({ data })).subscribe(
              (result2) => {
                const r: any = result2;
                if (!r.ok) return;
              }
            );
          })
          .catch((err) => console.log("i am Error", err));
      } else {
        this.myToken = token.value;
        const data = {
          tokenRaw: token,
          platform: Capacitor.getPlatform(),
          token: this.myToken,
        };
        (await this.api.deviceTokenRegister({ data })).subscribe((result) => {
          const r: any = result;
          if (!r.ok) return;
        });
      }
    });

    // Some issue with our setup and push will not work
    PushNotifications.addListener("registrationError", (error: any) => {
      // console.log(`registrationError?`, error);
      // alert('Error on registration: ' + JSON.stringify(error));
    });

    // Show us the notification payload if the app is open on our device
    PushNotifications.addListener(
      "pushNotificationReceived",
      (notification: PushNotificationSchema) => {
        // console.log(`pushNotificationReceived?`, notification);
        // alert('Push received: ' + JSON.stringify(notification));
      }
    );

    // Method called when tapping on a notification
    PushNotifications.addListener(
      "pushNotificationActionPerformed",
      (notification: ActionPerformed) => {
        // alert('Push action performed: ' + JSON.stringify(notification));
      }
    );
  }
}
